import { Routes } from '@angular/router';
import { EventListComponent } from './event-list/event-list.component';
import { EventComponent } from './event/event.component';
import { AddEventComponent } from './add-event/add-event.component';
import { CanActivateViaAuthGuard } from '../shared/guards/can-activate-via-auth-guard';
import { PermissionGuard } from '../shared/guards/permission-guard';
import { EventsResolver } from './service/events.resolver';
import { EventResolver } from './event/event.resolver';
import { CommissionComponent } from './payment/commission/commission.component';
import { EventMenuComponent } from '../menus/event-menu/event-menu.component';
import { AppMenuComponent } from '../menus/app-menu/app-menu.component';
import { AttachmentResolver } from './attachment/attachment.resolver';
import { RsvpComponent } from './rsvp/rsvp.component';
import { RsvpListResolver } from './rsvp-list/rsvp-list.resolver';
import { ReservationPageComponent } from './reservations/reservation-page/reservation-page.component';
import { ReservationCompareResolver } from './reservations/reservation.compare.resolver';
import { AdjustmentResolver } from './payment/adjustment.resolver';
import { ReservationResolver } from './payment/reservation.resolver';
import { LatestPaymentResolver } from './payment/latest-payment.resolver';
import { PaymentsResolver } from './payment/payments.resolver';
import { DashboardComponent } from './dashboard/dashboard-page/dashboard.component';
import { CanDeactiveReservationDetailTable } from './reservations/reservation-detail-table/reservation-detail-can-deactive';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [ CanActivateViaAuthGuard ],
    children: [
      {
        path: '',
        outlet: 'navigation',
        component: AppMenuComponent
      },
      {
        path: '',
        component: DashboardComponent
      }
    ]
  },
  {
    path: 'events',
    canActivate: [ CanActivateViaAuthGuard ],
    children: [
      {
        path: '',
        outlet: 'navigation',
        component: AppMenuComponent
      },
      {
        path: '',
        component: EventListComponent,
        resolve: {
          eventsData: EventsResolver
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: { view: 'default' }
      },
      {
        path: 'financial',
        component: EventListComponent,
        resolve: {
          eventsData: EventsResolver
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: { view: 'financial' }
      },
      {
        path: 'add',
        component: AddEventComponent,
        canActivate: [ PermissionGuard ],
        data: { allowedPermissions: [ 'addevent' ] }
      }
    ]
  },
  {
    path: 'event/:id',
    canActivate: [ CanActivateViaAuthGuard ],
    resolve: {
      eventsData: EventResolver
    },
    children: [
      {
        path: '',
        outlet: 'navigation',
        component: AppMenuComponent,
        children: [
          {
            path: '',
            component: EventMenuComponent,
            outlet: 'event'
          }
        ]
      },
      {
        path: '',
        component: EventComponent,
        resolve: {
          attachmentData: AttachmentResolver
        }
      },
      {
        path: 'edit',
        component: EventComponent,
        resolve: {
          attachmentData: AttachmentResolver
        },
        canActivate: [ PermissionGuard ],
        data: { allowedPermissions: [ 'editevent' ] }
      },
      {
        path: 'commission',
        component: CommissionComponent,
        resolve: {
          reservationData: ReservationResolver,
          adjustmentData: AdjustmentResolver,
          latestPaymentData: LatestPaymentResolver,
          paymentsData: PaymentsResolver
        }
      },
      {
        path: 'rsvp',
        component: RsvpComponent,
        resolve: {
          rsvpData: RsvpListResolver
        }
      },
      {
        path: 'reservations',
        component: ReservationPageComponent,
        resolve: {
          reservations: ReservationCompareResolver
        }
      },
      {
        path: 'reservations/detail',
        component: ReservationPageComponent,
        resolve: {
          reservations: ReservationCompareResolver
        },
        canDeactivate: [CanDeactiveReservationDetailTable]
      }
    ]
  }
];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event.routes.ts